import { get } from "lodash";
import { Store } from "redux";
import { UserDataState } from "../utils/types";

export const userDataSelector = (store: Store): UserDataState =>
  get(store, "userData", {});

export const isUserInAWFlows = (store: Store): boolean =>
  get(store, "capi.featureToggles.enableAWFlows", false);
